// extracted by mini-css-extract-plugin
export default {"profileIcon":"styles_profileIcon__if09V","profileBox":"styles_profileBox__dfRLq","menuItem":"styles_menuItem__J8h8a"};